import React from 'react';
import ProgressiveOverlay from "../PrgressiveOverlay/progressiveOverlay";
class MWebCalendar extends React.Component {
   
    constructor(props) {
        super(props);
        this.state = {
            areaName: "Goa",
            overlay: true,
            activeTab: null,
            isDateLess: true,
        }
        this.changeArea = this.changeArea.bind(this);
        this.openOverlay = this.openOverlay.bind(this);
        this.closeOverlay = this.closeOverlay.bind(this);
        this.changeActiveTab = this.changeActiveTab.bind(this);
    }

    closeOverlay() {
        this.setState({
            overlay: false,
            activeTab: null
        });
        var element = document.querySelector("body");
        element.classList.remove("noScroll");
        this.props.changeCalendar();
    }

    openOverlay(index) {
        this.setState({
            overlay: true,
            activeTab: index
        });
        var element = document.querySelector("body");
        element.classList.add("noScroll");
    }

    changeActiveTab(index) {
        this.setState({
            activeTab: index
        });
    }

    changeArea(area) {
        this.setState({
            areaName: area
        });
    }
    handleDatelessChange(status) {
        this.setState({isDateLess: status})
    }

    componentDidMount() {
        if(this.props.showCalendar){
            this.openOverlay(1)
        }
    }
    render() {
        const { areaName, overlay, activeTab } = this.state;
        const { moveToFunnelParams, page, isBusCard } = this.props
        return (
            <>
                <ProgressiveOverlay
                    activeTab={activeTab}
                    changeArea={this.changeArea}
                    closeOverlay={this.closeOverlay}
                    changeActiveTab={this.changeActiveTab}
                    moveToFunnelParams={moveToFunnelParams}
                    page={page}
                    isBusCard={isBusCard} />
            </>
        );
    }
}

export default MWebCalendar;
